export default __webpack_public_path__ + "static/media/indian_equity.09530a63.svg";